// 参数悬浮说明字典 (20260719)
// 唯一事实源: docs/PARAM_DICTIONARY.md (274 字段全量, 逐参数对引擎源码核写)
// 本文件是其面板蒸馏版: key = web camelCase 参数名, 值 = 鼠标悬浮展示文案。
// 修改流程: 先改 PARAM_DICTIONARY.md, 再同步此处; 不要只改这里。
// 口径约定: "×R"=乘以个股风险标尺R(=max(昨日实测振幅或epPriorRangePct, epRFloor));
//          "×Rp"=W_OPEN族专用, Rp=max(epWopenRp或epPriorRangePct, 1%)。

export const PARAM_DESCS: Record<string, string> = {
  // ===== ep 核心族 (extreme_pair 极值配对, 全池现役) =====
  epMomSec: "动量回看窗(秒): 冲刺检测的时间窗, 计算窗内绝对涨跌幅。调小=对急拉急杀更敏感、信号更多; 调大=只认更持续的冲刺。参数体检按股标定(用友75/中概90)。",
  epSp: "急涨跌门槛(%, 绝对值, 不乘R): 动量窗内涨跌幅≥此值才算冲刺成立。调大=只接更猛的冲刺, 单数少而质量高(用友1.0挡掉假回摆日-454); 调小=灵敏但噪声单增多。",
  epRevSec: "反转确认窗(秒): 冲刺后须在此秒数内出现反向走势(现价反超N秒前价)才确认动量衰竭、允许入场。调小=抢先手; 调大=确认更足但入场价更差。",
  epNear: "贴日内极值阈值(×当日振幅): 入场时现价距日低(低吸)/日高(高抛)的距离须≤near×当日振幅。越小越贴极值, 入场位置越好但机会越少。",
  epCd: "同向开仓冷却(秒): 平仓后同方向再开的最短间隔, 防止同一波行情反复机枪开仓。",
  epPriorRangePct: "个股振幅基准R(%): 风险标尺先验值。实际 R=max(振幅基准, epRFloor), 全族×R参数(止盈/止损/闸)以R为量纲, 实现按股自适应。",
  epRFloor: "R下限(%): 风险标尺的保底值, 防止低波动股把止盈止损压得过窄导致费用侵蚀。",
  epActMult: "止盈激活系数(×R): 浮盈≥actMult×R 进入追踪(武装)状态, 保底 epActFloor。调小=更早武装更早锁利; 调大=让利润先跑。",
  epTrailMult: "武装后回撤出场系数(×R): 武装后从最优价回撤 trailMult×R 即市价落袋, 保底 epTrailFloor。振幅小的股此值过大会严重侵蚀利润。",
  epSlMult: "止损系数(×R): 逆向浮亏≥slMult×R 市价砍仓, 保底 epSlFloor。",
  epActFloor: "止盈激活下限(小数, 0.008=0.8%): ×R算出的激活线低于此值时取此值。",
  epTrailFloor: "回撤出场下限(小数, 0.02=2%): ×R回撤线的保底。",
  epSlFloor: "止损下限(小数, 0.03=3%): ×R止损线的保底。",
  epGateMult: "振幅闸(×R): 当日实际振幅≥gateMult×R 才开工。死水日振幅不足, 做T只亏费用, 直接不做。",
  epObsSec: "dwell入场·观察窗(秒): 低点须持稳N秒不创新低才确认底(现役feishu入场不走此参数)。",
  epHoldFrac: "dwell入场·持稳比例: 低点须稳过观察窗的该比例(现役feishu入场不走此参数)。",
  epEntryRev: "dwell入场·反转比例: 从低点反弹该比例才买入(现役feishu入场不走此参数)。",
  epEntryMode: "入场范式: feishu=动量衰竭+贴极值+快反转(现役全池) / dwell=观察窗持稳+反弹(旧)。",
  epTailNoOpenMin: "尾盘禁开(分钟): 收盘前N分钟不开新腿, 只做收尾管理(引擎墙钟执行)。",
  epOpenNoOpenMin: "开盘禁开(分钟): 开盘后N分钟不开新腿, 避开竞价惯性(回测3分最优)。",
  epSlip: "撮合滑点(小数): 回测/SIM撮合的滑点假设, 与部署口径一致(0.0005=万5)。",
  epDirection: "方向限制: both=低吸+高抛双向 / long=仅低吸 / short=仅高抛。",
  epOpenGateMin: "早盘条件闸窗口(分钟): 开盘N分钟内启用加强确认, 0=关。",
  epOpenSpMult: "早盘sp倍率: 早盘窗口内急涨跌门槛×此倍率(>1=早盘要求更强冲刺), 1.0=不加强。",
  epVetoEnable: "真逐笔否决器开关: 主动买占比过低时否决低吸(仅dwell模式参与)。",
  epVetoMin: "主动买占比否决线: 低吸要求主动买占比≥此值(买盘有人接才接刀), 高抛镜像。",
  epLockFrac: "利润保底锁: 武装后至少留住峰值浮盈×此比例(0.5=锁一半), 0=关。防大肉单回吐成小肉。",
  epTgExemptNear: "TG极值豁免: 距官方日高/低≤此比例×日振幅的反转单豁免趋势闸veto(空=全局默认0.25, 0=关)。配合75s成熟度闸与豁免烧毁。",
  epS4SizeAdopt: "S4采纳器: advisor体制建议权重减仓(单边日逆势开仓量×w, 夹取0.2-1.0), 减权不禁止。空/0=关, 1=开。",
  epRideTrailMult: "顺势宽尾: ER≥阈值且趋势与持仓同向时 trail×此倍数(空=全局默认1.8, 1=关)。宽尾期间保底锁让位。",
  epReentryCdFrac: "止盈再入折扣: 止盈类平仓后同向再入冷却×此比例(空=全局默认0.35, 1=关)。止损平仓与反向单全额冷却。",
  epAmpTpFrac: "振幅落袋线: 浮盈达 该比例×当日实际振幅 直接落袋, 0=关。",
  epEsjRestore: "同日快照回灌开关: 0=禁用(账本唯一真源, 默认), 1=仅应急诊断用。",
  epErEnable: "模块内单边ER闸: 0=关(默认, 与趋势闸功能重叠, 全池用趋势闸)。",
  epErThresh: "模块ER阈值: ER≥此判单边禁逆势接刀(实测tick级分布99%<0.2, 0.5从不咬合)。",
  epErWin: "模块ER窗口(秒)。",

  // ===== 准入六闸 / S4 建议模式 =====
  epTrendGateEnable: "趋势闸: 0=关 / 0.5=影子(只记日志) / 1=生效。滚动窗ER判单边, 单边日禁逆势开腿。",
  epTrendGateWin: "趋势闸滚动窗(分钟): 计算方向效率ER的回看窗(双窗验证最优120)。",
  epTrendGateThresh: "趋势闸ER阈值: 窗内|净位移|/路径总长≥此值判单边(双窗验证最优0.50)。",
  epTrendGateBootDev: "开盘引导偏离: 趋势闸窗口未形成期用VWAP偏离简判(0.004=0.4%), 0=关。",
  epOscEnable: "振荡指数闸: 0=关 / 0.5=影子 / 1=生效。折返次数不足判定今日不宜做T。",
  epOscMin: "振荡指数阈值: 指数低于此值=今日折返太少(单边或死水), 不开工。",
  epOscZzFrac: "折返判定幅度(小数, 0.0015=0.15%): 反向走过此幅度才计一次折返。",
  epGuardEnable: "护栏两刀: 0=关 / 0.5=影子 / 1=生效。刀①贴极值禁追、刀②开盘区间未张开禁贴边。",
  epNearExtGuard: "刀①距日极值护栏(×R): 距日低此距离内禁贴底开空, 距日高禁贴顶追多(防抄在半山腰)。",
  epRangeMatureFrac: "刀②区间成熟度(×R): 开盘30分钟内贴边开腿要求日内区间已张开≥此幅度。",
  epSsGuardEnable: "单边日守卫(ep版): 0=关 / 0.5=影子 / 1=生效。阈值复用全局 singleSideEffThreshold。0726起并入趋势日准入单闸层2(双向禁开)。",
  epWopenCUpCapFrac: "C轨追多透支帽(×Rp): 升破锚追多时, 锚上涨幅已超 cap×Rp 则放弃追(防顶部追多)。0=关。0726判决+485过闸, 先导1.2。",
  epRegimeAdopt: "S4建议模式采纳: 0=只记录建议 / 1=生效(条件闸通过后才可开)。",
  epStopDualCdSec: "止损后双向禁开秒数(0=关)。注意: 这是收紧闸, 开启会压出手率。",
  epRaBandFrac: "体制锚: 回踩/反抽带宽(×前日振幅%)。仅 epRegimeAnchor=1 时生效。",
  epRaBreakFrac: "体制锚: 穿越VWAP容忍幅(×前日振幅%)。仅 epRegimeAnchor=1 时生效。",
  epRaTtl: "体制锚: 体制闩锁新鲜度(秒), 超时回落原锚。仅 epRegimeAnchor=1 时生效。",
  epRegimeEffMin: "S4单边判定·方向效率下限(%): |收-开|/(高-低)。",
  epRegimeMinRangePct: "S4单边判定·当日振幅下限(%)。",
  epRegimeOpenMin: "S4接管起点(开盘N分钟后): 默认30=W_OPEN窗口结束后, 调小会吃W_OPEN弹药。",

  // ===== FLIP / DUAL-SLOT / 回踩 / 孤儿腿 =====
  epFlipEnable: "反手开关: 止损腿被砍且浮亏达标时反方向立即开新腿(输家变燃料), 0=关。热参可一键撤回。",
  epFlipMinAdverse: "反手浮亏门槛(小数): 旧腿浮亏≥0.4%才允许反手, 防小噪声止损也反手。",
  epFlipMinHoldSec: "反手最小持腿龄(秒): 太年轻的腿被砍不反手(可能只是入场时机差)。",
  epFlipMaxDay: "每股每日反手上限次数。",
  epFlipCdSec: "反手后冷静期(秒): 反手腿平仓后较长冷却, 防连环反手。",
  epFlipPxProtFrac: "反手价格保护(小数): 开新腿时价格偏离触发价超此幅度则放弃(防追飞)。",
  epSlot2Enable: "赢家加注二腿开关: 一腿浮盈达标且已武装时同向再开一条独立小腿, 0=关。20日回放+8,592待扩池。",
  epSlot2MinFav: "二腿加注门槛(小数): 一腿浮盈≥1.5%才允许加注。",
  epSlot2Size: "二腿尺寸(×每轮股数): 0.3=加注腿只用3成弹药。",
  epSlot2MaxDay: "每股每日二腿上限次数。",
  epSlot2BeFrac: "二腿开出后一腿止损抬至保本+此幅度(残余风险帽, 防双腿同杀)。",
  epSlot2StopMult: "二腿止损收紧倍数: 加注腿止损=正常×0.6, 快刀止损防2R双杀。",
  epEntryRetraceFrac: "回踩入场比例: 信号确认后不追价, 等回踩此比例再进(0=关=确认即市价)。",
  epEntryWaitSec: "回踩等待(秒): 超时未跑远则兜底市价进。",
  epEntryGiveupFrac: "回踩放弃线(小数): 等待期价格离确认价超0.6%则放弃该单, 不追飞。",
  epOrphanEnable: "孤儿腿保守管理: 重启后模块无记忆的持仓差额腿不裸奔到尾盘, 以首见价为锚极简退出。",
  epOrphanTp: "孤儿腿目标(相对首见价, 0.003=0.3%)。",
  epOrphanSl: "孤儿腿止损(相对首见价, 0.004=0.4%)。",

  // ===== W_OPEN 开盘极值武器族 (09:33-10:00) =====
  epWopenEnable: "开盘武器总开关: 0=关 / 1=仅信号(只记日志不下单) / 2=自动开火。另有fubao cron总闸(当日亏超线自动回0)守护。",
  epWopenRp: "昨日实测振幅%(数据字段, 夜批自动更新, 勿手调): W_OPEN族×Rp计算基准, 0=回退epPriorRangePct, 1%下限。",
  epWopenMinSod: "开火下界(当日秒数, 34386=09:33:06): 开盘前3分钟纯竞价噪声不参与。",
  epWopenWinEnd: "跟踪窗截止(当日秒数, 36000=10:00): 过此时刻W_OPEN停用, 交回常规入场。",
  epWopenSurgeFrac: "B轨冲高/急跌幅度门槛(×Rp): 开盘从锚点单边走出≥0.5×Rp才算冲过头。调大=只做大过冲。",
  epWopenRetraceFrac: "B轨回摆确认幅度(×Rp): 从极值往回走≥0.15×Rp才开火。调大=确认足但让利多。",
  epWopenPeakAgeSec: "B轨峰龄门槛(秒): 极值须已保持150秒未刷新, 证明冲势衰竭。调小=抢先手但易被二次冲顶。",
  epWopenTickRatio: "B轨方向tick占比: 最近tick中顺开仓方向占比≥60%才开火(盘口投票确认回摆是真的)。",
  epWopenCAuto: "C轨实弹子开关: enable=2且此项=1, C轨(破锚追势)才真实开腿; 可单独关C轨只留B轨。",
  epWopenCBreakFrac: "C轨破锚幅度(×Rp): 击穿开盘锚点≥0.25×Rp视为破位。",
  epWopenCMomSec: "C轨速度测量窗(秒): 用90秒前价格算跌速/涨速。",
  epWopenCMomFrac: "C轨速度门槛(×Rp): 窗内跌幅≥0.20×Rp才算急。破锚+急速双条件缺一不追。",
  epWopenCActbuyMax: "C轨抛压确认: 主动买占比<40%视为抛压主导允许追空(做多镜像>60%)。",
  epWopenCTickRatio: "C轨盘口降级票: 主动买数据缺失时, 用方向tick占比≥70%替代确认。",
  epWopenCExtCapFrac: "C轨峰值保护帽(×Rp): 当日已先冲高超锚点0.30×Rp则禁追空(先拉后破多为洗盘非瀑布)。",
  epWopenStopFrac: "W/C族止损(×Rp): 开盘腿波动大, 止损0.35×Rp比常规腿宽。",
  epWopenActFrac: "W/C族止盈激活(×Rp, 保底0.6%): 浮盈达0.15×Rp进入追踪。",
  epWopenTrailFrac: "W/C族回撤出场(×激活值, 保底0.3%): 武装后从最优价回撤激活值×0.5落袋。注意乘的是激活值不是Rp。",
  epWopenQtyFrac: "W_OPEN仓位比例(×每轮股数): 0.5=开盘腿只用半份弹药, 实验期风险减半。",

  // ===== 通用底座: 仓位/风控/熔断 =====
  tradeMode: "运行模式: simulation=模拟(SIM虚拟撮合, 不碰真钱) / live=实盘(还须过Gate3文件+全局开关+调用方三重门才真下单)。空值按fail-closed处理为模拟。",
  activeTemplate: "场景化参数模板: 切换仅改表单预设, 点保存才落库生效。",
  tradeLotSize: "每轮交易股数=每条腿的下单数量, 最核心仓位参数。T+1股票受可卖余量约束(用友3000/底仓10000); T+0 ETF可高配(513050按SIM验证口径89%)。",
  maxPositionShares: "最大持仓量硬上限(股): 任何买入不得使持仓超过此值。",
  baseHolding: "底仓基准(股): X0收盘强制做平的目标, 收盘前把持仓拉回此值。切实盘前必须核实=真实底仓(SIM污染事故教训)。0=回退maxPositionShares。",
  maxDailyRounds: "单日最大交易轮次, 防过度交易(与epCd冷却双保险)。",
  maxDailyLossAmount: "单日最大亏损额(元): per-monitor硬熔断, 当日已实现亏损达此值该监控停止交易。第一道保命闸。",
  dailyPnlStopThreshold: "当日盈亏软停线(元, 负数): 亏到此值触发pause至次日(可手工恢复), 比硬熔断先行缓冲。",
  maxConsecutiveStopLoss: "连续止损N次自动暂停: 连亏说明今天读不懂这只股。",
  stopLossPauseMinutes: "连损暂停时长(分钟), 到点自动恢复。",
  stopLossCooldownSeconds: "单次止损冷却(秒): 期间不开新仓, 防原地报复性进场。",
  maxDailyResume: "熔断后每日最大手工恢复次数, 超过拒绝恢复。",
  allowZeroBaseOpen: "零底仓开仓: 0=禁止零底仓自动开新仓(红线默认), 1=允许。",
  marketCircuitBreaker: "大盘熔断保护开关(7-17暴跌日实测拦截513050追加亏损)。",
  marketDropPausePct: "大盘跌超此值(%)暂停新开仓, 已有腿正常管理。",
  marketDropStopPct: "大盘跌超此值(%)全面停止交易。",
  marketIndexCode: "监控的大盘指数代码(默认sh000001上证指数)。",
  singleSideBlockEnabled: "单边日禁做T总开关: 全天单边行情做回归型T0必被碾压。",
  singleSideEffThreshold: "单边判定·方向效率阈值(%): |收-开|/(高-低)超此值判单边日(ep_ss_guard复用此阈值)。",
  singleSideMinRangePct: "单边判定·最小振幅(%): 振幅太小不判单边(小幅漂移不算趋势)。",

  // ===== 费率 / 执行 / 时段 =====
  commissionRate: "佣金率(万分之, 单边): 兴业实际万1.2。费率错=模拟盘系统性失真。",
  minCommission: "最低佣金(元/笔): 小单实际费率被此抬高。",
  stampTaxRate: "印花税(‰, 仅卖出): 股票0.5, ETF=0(费改20260716)。",
  transferFeeRate: "过户费(万分之): 股票0.2, ETF=0。",
  orderStrategy: "挂单价策略: opponent=对手价(立即可成) / opponent_plus1=让一档 / weighted_mid=加权中间价 / smart_chase=智能追价。",
  smartChaseWaitMs: "smart_chase每档等待毫秒数。",
  smartChaseMaxTicks: "smart_chase最多追价档数, 追不到放弃。",
  slippageProtectPct: "滑点保护(%): 成交价偏离预期超此值的信号拒绝执行。",
  simMarketSlippagePct: "SIM撮合滑点(%): dry_run市价单优先吃bid1/ask1对手价, 缺盘口时按此滑点模拟。只影响模拟。",
  joinAuction: "0=不参与集合竞价(默认), 竞价时段信号不下单。",
  tailProtectMinutes: "尾盘保护(分钟): 收盘前N分钟停开新轮, 只做收尾(引擎级, 与epTailNoOpenMin双层)。",
  openPauseEnabled: "开盘暂停开关: 1=开盘后暂停交易N分钟。",
  openPauseMinutes: "开盘暂停时长(分钟, 默认5=09:30-09:35), 避开开盘最乱时段, 0=不暂停。",
  positionMode: "策略模式: extreme_pair=极值配对(全池现役) / paired/pyramid/vwap_atr/zigzag_fusion/extreme_dynamic=历史模式。",

  // ===== Legacy: S1/S2 配对模式 (extreme_pair 下不参与决策) =====
  s1CallbackPct: "[legacy paired] S1(先卖后买)触发: 从日内高点回调此比例(%)进入卖出观察。",
  s1ObserveWindowSec: "[legacy paired] S1观察窗(秒): 窗内确认跌势才真卖。",
  s1ConfirmDropMaxPct: "[legacy paired] S1确认跌幅上限(%): 跌太多追不上, 放弃。",
  s1StopLossRisePct: "[legacy paired] S1止损: 卖出后反涨此比例(%)市价买回认错。",
  s2BouncePct: "[legacy paired] S2(先买后卖)触发: 从日内低点反弹此比例(%)进入买入观察。",
  s2ObserveWindowSec: "[legacy paired] S2观察窗(秒)。",
  s2ConfirmRiseMinPct: "[legacy paired] S2确认涨幅下限(%): 低于费用+滑点0.23%必亏, 故0.30。",
  s2StopLossDropPct: "[legacy paired] S2止损: 买入后继续跌此比例(%)砍。",
  extremeHoldBreakBufferPct: "[legacy paired] 极值企稳入场·破极值缓冲(%)。",
  limitOrderOffsetPct: "[legacy paired] 反向限价单偏移(%): 卖后挂低此值买回/买后挂高此值卖出。",
  limitOrderTimeoutSec: "[legacy paired] 限价单超时(秒): 到时撤单评估强平(180防超时强平锁亏)。",
  signalMinVolumeRatio: "[legacy] 信号确认最小量能倍数, 0=不过滤。",
  signalMaxSpreadPct: "[legacy] 信号确认最大买卖价差(%), 0=不过滤。",
  signalMinNetProfitPct: "[legacy] 预期净利润(扣费后)低于此值(%)的信号拒绝。",
  volatilityFilter: "[legacy] 开工前波动率筛选开关, 0=关(默认)。",
  minDayRangePct: "[legacy] 最小日内振幅(%): 低于此值不适合做T。",
  maxDayRangePct: "[legacy] 最大日内振幅(%): 超过此值风险太高不做。",
  minTurnoverVal: "[legacy] 最小成交额(元): 低于此值流动性不足(早盘按时间比例折算)。",
  takeProfitModeS1: "[legacy paired] S1止盈方式: 0=固定限价 / 1=追踪止盈(达激活线后从极值回撤触发)。",
  takeProfitModeS2: "[legacy paired] S2止盈方式: 0=固定限价 / 1=追踪止盈。",
  takeProfitActivationPctS1: "[legacy paired] S1追踪激活线(%): 跌达此值激活追踪最低点。",
  takeProfitActivationPctS2: "[legacy paired] S2追踪激活线(%): 涨达此值激活追踪最高点。",
  takeProfitTrailPctS1: "[legacy paired] S1回撤触发(%): 从最低点反弹此值市价买回。",
  takeProfitTrailPctS2: "[legacy paired] S2回撤触发(%): 从最高点回落此值市价卖出。",
  takeProfitSchedule: "[legacy paired] 分时段止盈模式调度(如09:30-10:00=0,10:00-14:30=1), 空=禁用。",
  trailMinTickVolumeS1: "[legacy paired] S1极值更新最小tick量: 防1手碎股打点。",
  trailMinTickVolumeS2: "[legacy paired] S2极值更新最小tick量。",
  trailForceCloseMaxHoldSecS1: "[legacy paired] S1持仓强平兜底(秒): 超时无论如何平仓。",
  trailForceCloseMaxHoldSecS2: "[legacy paired] S2持仓强平兜底(秒)。",
};

// 取描述: 未收录 key 返回 undefined, 调用方自行降级不显示
export function paramDesc(key: string): string | undefined {
  return PARAM_DESCS[key];
}
